import { styled } from "themes"

export const Footer = styled.div`
  margin-top: -60px;
`
